import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { filter, firstValueFrom } from 'rxjs';
import { isUpsellSetupFlowEnabled } from 'src/app/constants/upsell-setup-flow.constants';
import { UPSELL_REGISTRY } from 'src/app/pages/upgrade/upsell-registry';
import { AttendancePlanService } from 'src/app/services/attendance/attendance-plan.service';
import { GrowthBookService } from 'src/app/services/growthbook/service';
import { AuthState } from 'src/app/store/auth/auth.state';

/**
 * Guards /attendance with plan-aware access:
 * - Basic + flag on → upgrade upsell
 * - Std/Premium manager (role) without schedules → setup page
 * - Otherwise → allow through to report
 */
export const attendanceSetupRedirectGuard: CanActivateFn = async () => {
  const store = inject(Store);
  const router = inject(Router);
  const growthbook = inject(GrowthBookService);
  const attendancePlanService = inject(AttendancePlanService);

  await firstValueFrom(growthbook.initialized.pipe(filter(x => x)));

  const config = UPSELL_REGISTRY.get('attendance');
  const company = store.selectSnapshot(AuthState.company);

  if (company.pricingPlan?.includes('basic')) {
    const flagOn = !!growthbook.getFeatureValue(config?.featureFlagKey, null);
    return flagOn
      ? router.createUrlTree(['/upgrade', 'attendance'])
      : true;
  }

  if (!isUpsellSetupFlowEnabled(growthbook)) {
    return true;
  }

  if (company.role === 'manager' && await attendancePlanService.needsAttendanceSetup(company)) {
    return router.createUrlTree(['/setup', 'attendance']);
  }

  return true;
};
